import React, { useEffect, useState } from "react";
import { AnswerArea, Card, InputAnswerArea } from "./StyledComponent";
import styled from 'styled-components';

// Define a styled component with conditional styles
const StyledInputAnswerArea = styled(InputAnswerArea)`
    border: 2px solid ${({ isActive, isNotEmpty }) => (isActive ? '#003B7F' : isNotEmpty ? 'green' : '#ccc')};
    // Add any other styles you want here
`;

const Od = ({ item, setUserAnswer }) => {
    const [consigneValues, setConsigneValues] = useState(() => {
        return item.consigne.map(() => "");
    });

    // New effect to reset consigneValues when item changes
    useEffect(() => {
        setConsigneValues(item.consigne.map(() => ""));
    }, [item]);

    useEffect(() => {
        setUserAnswer(consigneValues);
    }, [consigneValues]);

    if (!item || !item.consigne || !Array.isArray(item.consigne)) {
        return <div>Invalid data for od type</div>;
    }

    const handleCardClick = (consigneItem) => {
        const updatedValues = [...consigneValues];
        const itemIndex = updatedValues.findIndex(value => value === consigneItem);

        if (itemIndex !== -1) {
            updatedValues[itemIndex] = "";
        } else {
            const firstEmptyIndex = updatedValues.findIndex(value => value === "");
            if (firstEmptyIndex !== -1) {
                updatedValues[firstEmptyIndex] = consigneItem;
            }
        }

        setConsigneValues(updatedValues);
        setUserAnswer(updatedValues);
    };

    return (
        <div>
            <p className="py-4">Cliquez sur les cartes pour sélectionner les nombres :</p>
            <div className="flex gap-4 flex-wrap items-center justify-center">
                {item.consigne.map((consigne, index) => (
                    <StyledInputAnswerArea
                        key={index}
                        value={consigneValues[index] || ""}
                        className="mb-3 p-2"
                        readOnly
                        placeholder=""
                        isActive={consigneValues[index] !== ""}
                        isNotEmpty={consigne !== ""}
                        onClick={() => {
                            if (consigneValues[index]) {
                                const updatedValues = [...consigneValues];
                                updatedValues[index] = "";
                                setConsigneValues(updatedValues);
                                setUserAnswer(updatedValues);
                            }
                        }}
                    />
                ))}
            </div>
            <div className="flex gap-4 flex-wrap items-center justify-center mt-4">
                {item?.consigne.map((consigneItem, index) => {
                    return (
                        <Card
                            key={index}
                            style={{
                                borderColor: consigneValues.includes(consigneItem)
                                    ? "#003B7F"
                                    : "#ccc",
                            }}
                            onClick={() => handleCardClick(consigneItem)}
                        >
                            {consigneItem}
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};

export default Od;
